import React from 'react'
import LazyLoad from 'react-lazyload'
import './index.scss'

const MixBlock2 = (props) => {
  const { id, pid, config, rowType, clickTo } = props
  let bgColor = config.bgColor
    ? config.bgColor
    : rowType === 'bgBlock'
    ? 'rgba(0,0,0,0.8)'
    : '#fff'
  return (
    <div
      style={
        rowType !== 'bgBlock'
          ? { background: bgColor }
          : {
              backgroundImage: `linear-gradient(${bgColor},${bgColor}),url(${config.imgSrc}) center center`,
            }
      }
      className={`${rowType || 'imageBlock'} lego_rowsBlock2`}
      onClick={() => clickTo('mixedBlock', config.deepLink, config.link, id)}
    >
      <div className={`block2TextContent ${config.textModel || ''}`}>
        <div className="block2text">
          <p className="block2Title1">{config.title1}</p>
          <p className="block2Title2">{config.title2}</p>
        </div>
        <div className="enterNow">
          <span>{config.enterText || '马上进入'}</span>
          <span className="rightArraw">{'>'}</span>
        </div>
      </div>
      {rowType !== 'bgBlock' && (
        <div className="block2ImgContent">
            <LazyLoad overflow={true} height={100} className="lazyImgBox">
                <img src={config.imgSrc}></img>
            </LazyLoad>
        </div>
      )}
    </div>
  )
}

export default MixBlock2
